/* Клінічна якість (/quality/cards, batch B14). Kept apart from uk.ts/en.ts to keep merges small. */
export const clinqUk = {
  'nav.clinq': 'Клінічна якість',
  'perm.clinq.read': 'Клінічна якість: зауваження до карток власних візитів',
  'perm.clinq.read_all': 'Клінічна якість: зауваження всіх лікарів, звіт з антимікробних і журнал рецептів',
  'perm.clinq.calls': 'Клінічна якість: контрольні дзвінки (результат, ускладнення)',
  'perm.clinq.work': 'Клінічна якість: оцінка евтаназії та облік тіл',
  'perm.clinq.manage': 'Клінічна якість: правила перевірки карток і дзвінків, список речовин, подання звіту',
  'today.myFindings': 'Зауваження до моїх карток',
  'today.noFindings': 'Зауважень немає — картки в порядку',
  'clinq.title': 'Клінічна якість',
  'clinq.subtitle':
    'Перевірка медичних карток Enote, контрольні дзвінки після лікування, квартальний звіт з протимікробних і журнал рецептів, оцінка евтаназії та облік тіл.',
  'clinq.noAccess': 'Немає доступу до розділу',
  'clinq.toConfirm': 'уточнити',
  'clinq.toConfirmHint': 'Значення запропоновано з документів клініки й чекає підтвердження головного лікаря',
  'clinq.changePet': 'Змінити',
  'clinq.petSearch': 'Кличка, власник або чип',
  'clinq.petNotFound': 'Нікого не знайдено в Enote',
  'clinq.lastVisit': 'візит',
  'clinq.ov.openTotal': 'відкритих зауважень',
  'clinq.ov.myOpen': 'моїх зауважень',
  'clinq.ov.callsDue': 'дзвінків на сьогодні',
  'clinq.ov.bodies': 'тіл на зберіганні',
  'clinq.ov.bodiesOverdue': 'тіл понад термін',
  'clinq.ov.reportDue': 'звіт за {q} — подати до',
  'clinq.ov.reportDone': 'звіт за {q} подано',
  'clinq.tab.cards': 'Картки',
  'clinq.tab.calls': 'Контрольні дзвінки',
  'clinq.tab.antimicrobial': 'Антимікробні',
  'clinq.tab.euthanasia': 'Евтаназія й тіла',
  'clinq.statusFilter': 'Статус',
  'clinq.ruleFilter': 'Правило',
  'clinq.anyRule': 'Усі правила',
  'clinq.onlyMine': 'Лише мої візити',
  'clinq.rules': 'Правила',
  'clinq.lintRun': 'Перевірити зараз',
  'clinq.lintDone': 'Перевірено візитів: {n}; нових зауважень: {open}; виправлено: {fixed}',
  'clinq.noFindings': 'Відкритих зауважень немає',
  'clinq.noFindingsHint': 'Bridge щодня перевіряє закриті візити Enote за правилами (діагноз, вага й температура, дози, згоди, аналізи, рекомендації).',
  'clinq.notLinked': 'Ваш обліковий запис не пов’язано з лікарем Enote — попросіть адміністратора вказати його в «Користувачах».',
  'clinq.colRule': 'Правило',
  'clinq.colVisit': 'Візит',
  'clinq.colPatient': 'Пацієнт',
  'clinq.colDoctor': 'Лікар',
  'clinq.colDetail': 'Що не так',
  'clinq.colStatus': 'Статус',
  'clinq.visit': 'Візит',
  'clinq.enoteId': 'ID Enote',
  'clinq.autoFixed': 'виправлено в Enote',
  'clinq.moreRows': 'Ще {n} — уточніть фільтр',
  'clinq.markedFixed': 'Позначено виправленим — наступна перевірка це підтвердить',
  'clinq.fixed': 'Виправлено',
  'clinq.accept': 'Прийняти виняток',
  'clinq.reopen': 'Відкрити знову',
  'clinq.acceptTitle': 'Прийняти як обґрунтований виняток',
  'clinq.reopenTitle': 'Відкрити зауваження знову',
  'clinq.note': 'Примітка',
  'clinq.acceptHint': 'Чому це не порушення (обов’язково).',
  'clinq.byDoctor': 'За лікарями (30 днів)',
  'clinq.colOpen': 'Відкриті',
  'clinq.colCritical': 'Критичні',
  'clinq.colFixed': 'Виправлено',
  'clinq.colAccepted': 'Винятки',
  'clinq.colVisits': 'Візитів',
  'clinq.noDoctor': 'Лікаря не вказано',
  'clinq.rulesTitle': 'Правила перевірки карток',
  'clinq.rulesHint': 'Пороги та списки слів налаштовуються; позначені «уточнити» чекають рішення головного лікаря.',
  'clinq.openCount': 'відкритих: {n}',
  'clinq.enabled': 'Увімкнено',
  'clinq.confirmed': 'Підтверджено',
  'clinq.severityLabel': 'Важливість',
  'clinq.severity.critical': 'Критично',
  'clinq.severity.warning': 'Увага',
  'clinq.severity.info': 'Інфо',
  'clinq.finding.open': 'Відкрите',
  'clinq.finding.fixed': 'Виправлено',
  'clinq.finding.accepted': 'Виняток',
  'clinq.param.keywords': 'Слова в типі візиту / послугах (до яких візитів застосовується)',
  'clinq.param.skip_keywords': 'Пропускати візити зі словами',
  'clinq.param.weight_keywords': 'Питання анамнезу з вагою',
  'clinq.param.temperature_keywords': 'Питання анамнезу з температурою',
  'clinq.param.stage_text': 'Тексти «стадія обстеження» (не обґрунтовують антимікробний)',
  'clinq.param.template_keys': 'Шаблони згод на операцію (ключі)',
  'clinq.param.record_keywords': 'Слова анестезіологічного запису',
  'clinq.param.checklist_keys': 'Чек-листи процесів, що зараховуються як запис',
  'clinq.param.require_weight': 'Вимагати вагу',
  'clinq.param.require_temperature': 'Вимагати температуру',
  'clinq.param.require_dose': 'Вимагати дозу',
  'clinq.param.require_course': 'Вимагати тривалість курсу',
  'clinq.param.accept_enote_text': 'Текст рекомендацій в Enote зараховується',
  'clinq.param.hours': 'Годин',
  'clinq.param.days': 'Днів',
  'clinq.param.days_before': 'Згода підписана не раніше ніж за (днів)',
  'clinq.callSearch': 'Клієнт або тварина',
  'clinq.callsCounters': 'Сьогодні: {today} · прострочено: {overdue}',
  'clinq.callRules': 'Правила дзвінків',
  'clinq.callsCreated': 'Створено дзвінків: {n}',
  'clinq.callsGenerate': 'Створити дзвінки',
  'clinq.noCallsDue': 'Контрольних дзвінків на сьогодні немає',
  'clinq.noCallsHint':
    'Дзвінки створюються автоматично через N днів після операції, виписки з ВРІТ або першого візиту — за правилами, які вмикає менеджер якості («Правила дзвінків»).',
  'clinq.colDue': 'Дата',
  'clinq.colReason': 'Привід',
  'clinq.colPhone': 'Телефон',
  'clinq.attempts': 'спроб: {n}',
  'clinq.record': 'Результат',
  'clinq.cancelCall': 'Скасувати дзвінок',
  'clinq.incidentRaised': 'Створено інцидент №{n} для лікарів',
  'clinq.recordTitle': 'Контрольний дзвінок: {pet}',
  'clinq.script': 'Що запитати',
  'clinq.result': 'Результат',
  'clinq.complicationHint': 'Буде створено інцидент «Ускладнення після лікування» — лікар отримає сповіщення.',
  'clinq.noAnswerHint': 'Дзвінок повториться завтра; після кількох спроб закриється як «не додзвонилися».',
  'clinq.callNote': 'Що сказав клієнт',
  'clinq.inquiryRef': 'Звернення колл-центру',
  'clinq.inquiryHint': 'Номер звернення, якщо дзвінок оформлено як звернення (необов’язково).',
  'clinq.reason': 'Причина',
  'clinq.callRulesTitle': 'Правила контрольних дзвінків',
  'clinq.callRulesHint': 'День N у документах клініки не вказано — значення запропоновані. Увімкніть правило, коли головний лікар підтвердить день.',
  'clinq.daysAfter': 'Через днів',
  'clinq.keywords': 'Слова',
  'clinq.keywordsHint': 'Через кому; шукаються в назвах препаратів без урахування регістру.',
  'clinq.callStatus.due': 'На сьогодні',
  'clinq.callStatus.planned': 'Заплановані',
  'clinq.callStatus.done': 'Виконані',
  'clinq.callStatus.cancelled': 'Скасовані',
  'clinq.result.ok': 'Все добре',
  'clinq.result.complication': 'Ускладнення',
  'clinq.result.revisit': 'Запрошено на повтор',
  'clinq.result.no_answer': 'Не відповідає',
  'clinq.trigger.visit_keywords': 'візит зі словами',
  'clinq.trigger.vrit_discharge': 'виписка з ВРІТ',
  'clinq.trigger.first_visit': 'перший візит',
  'clinq.anti.dimension': 'Розріз',
  'clinq.anti.name': 'Назва',
  'clinq.anti.group': 'Група',
  'clinq.anti.prescriptions': 'Рецептів',
  'clinq.anti.lines': 'Призначень',
  'clinq.anti.patients': 'Пацієнтів',
  'clinq.anti.year': 'Рік',
  'clinq.anti.quarter': 'Квартал',
  'clinq.anti.q': '{q} квартал',
  'clinq.anti.reportFor': 'Звіт щодо протимікробних за {q} квартал {y}',
  'clinq.anti.dueOn': 'подати до {date}',
  'clinq.anti.submitted': 'Подано {date} · {who}',
  'clinq.anti.overdue': 'Термін подання минув',
  'clinq.anti.notSubmitted': 'Ще не подано',
  'clinq.anti.undoSubmit': 'Скасувати позначку',
  'clinq.anti.markSubmitted': 'Позначити поданим',
  'clinq.anti.empty': 'Протимікробних призначень за квартал немає',
  'clinq.anti.emptyHint': 'Рецепти Enote зіставляються зі списком речовин ({n} активних) за словами в назвах препаратів.',
  'clinq.anti.bySubstance': 'За речовинами',
  'clinq.anti.byGroup': 'За групами',
  'clinq.anti.bySpecies': 'За видами тварин',
  'clinq.anti.byDoctor': 'За лікарями',
  'clinq.print': 'Друк',
  'clinq.register': 'Журнал рецептів',
  'clinq.antiOnly': 'Лише протимікробні',
  'clinq.registerSearch': 'Препарат, тварина або власник',
  'clinq.registerHint': 'Обов’язкові поля журналу (закон 2026, 11 полів — перелік уточнюється); порожні підсвічено червоним — заповніть їх у рецепті Enote.',
  'clinq.registerEmpty': 'Рецептів за період немає',
  'clinq.missing': 'немає',
  'clinq.field.number': 'Номер',
  'clinq.field.issued_at': 'Дата',
  'clinq.field.doctor': 'Лікар',
  'clinq.field.owner': 'Власник',
  'clinq.field.patient': 'Тварина',
  'clinq.field.species': 'Вид',
  'clinq.field.drug': 'Препарат',
  'clinq.field.substance': 'Діюча речовина',
  'clinq.field.dose': 'Доза',
  'clinq.field.frequency': 'Кратність',
  'clinq.field.duration': 'Тривалість',
  'clinq.field.route': 'Спосіб введення',
  'clinq.field.diagnosis': 'Діагноз',
  'clinq.field.visit_number': 'Візит',
  'clinq.substances': 'Протимікробні речовини',
  'clinq.substanceAdd': 'Додати речовину',
  'clinq.substancesHint': 'Список запропоновано (уточнити): препарат зараховується до першої речовини, слово якої є в його назві.',
  'clinq.substanceKey': 'Ключ',
  'clinq.substanceKeyHint': 'Латиницею: a-z, 0-9, _',
  'clinq.active': 'Активна',
  'clinq.euth.title': 'Оцінка перед евтаназією',
  'clinq.euth.new': 'Нова оцінка',
  'clinq.euth.hint':
    'Шкала якості життя HHHHHMM (7 критеріїв по 0–10), відносні показання — підтвердження другого лікаря, підписана згода на евтаназію (Згоди). Після проведення тіло потрапляє в облік.',
  'clinq.euth.empty': 'Оцінок ще немає',
  'clinq.euth.emptyHint': 'Створіть оцінку для пацієнта: заповніть шкалу, вкажіть показання й отримайте підпис згоди.',
  'clinq.euth.indication': 'Показання',
  'clinq.euth.score': 'Бали / поріг',
  'clinq.euth.consent': 'Згода',
  'clinq.euth.titleFor': 'Оцінка: {pet}',
  'clinq.euth.newHint': 'Знайдіть пацієнта в Enote і заповніть шкалу.',
  'clinq.euth.indicationHint': 'Відносні показання потребують другого лікаря.',
  'clinq.euth.reason': 'Показання / діагноз',
  'clinq.euth.scale': 'Шкала якості життя HHHHHMM',
  'clinq.euth.total': 'Разом {total} з {max} · поріг {threshold}',
  'clinq.euth.openConsents': 'Згенерувати згоду',
  'clinq.euth.second': 'Другий лікар',
  'clinq.euth.secondMissing': 'ще не підтвердив',
  'clinq.euth.confirmSecond': 'Підтвердити як другий лікар',
  'clinq.euth.approve': 'Затвердити',
  'clinq.euth.performed': 'Проведено',
  'clinq.euth.cancel': 'Скасувати оцінку',
  'clinq.indication.absolute': 'Абсолютні (медичні)',
  'clinq.indication.relative': 'Відносні',
  'clinq.consent.signed': 'Підписано',
  'clinq.consent.sent': 'Надіслано',
  'clinq.consent.draft': 'Чернетка',
  'clinq.consent.declined': 'Відмова',
  'clinq.consent.missing': 'Немає',
  'clinq.euthStatus.draft': 'Чернетка',
  'clinq.euthStatus.approved': 'Затверджено',
  'clinq.euthStatus.performed': 'Проведено',
  'clinq.euthStatus.cancelled': 'Скасовано',
  'clinq.body.title': 'Облік тіл',
  'clinq.body.new': 'Зареєструвати тіло',
  'clinq.body.hint': 'Де зберігається тіло, рішення власника й термін: без рішення тіло передають до крематорію через 14 днів (норматив). Адміністратори отримують нагадування.',
  'clinq.body.empty': 'Тіл на зберіганні немає',
  'clinq.body.died': 'Смерть',
  'clinq.body.location': 'Місце зберігання',
  'clinq.body.decision': 'Рішення власника',
  'clinq.body.keepUntil': 'Зберігати до',
  'clinq.body.releasedTo': 'Передано: {to}, {date}',
  'clinq.body.overdue': 'термін минув',
  'clinq.body.daysLeft': 'залишилось днів: {n}',
  'clinq.body.release': 'Видати',
  'clinq.body.newHint': 'Смерть у ВРІТ чи вдома: знайдіть пацієнта, вкажіть місце зберігання та рішення власника.',
  'clinq.body.branch': 'Філія',
  'clinq.body.releaseTitle': 'Видача тіла: {pet}',
  'clinq.body.releasedToLabel': 'Кому передано',
  'clinq.body.releasedToHint': 'Власник, крематорій або людина, що забрала.',
  'clinq.bodyStatus.stored': 'На зберіганні',
  'clinq.bodyStatus.released': 'Видані',
  'clinq.bodyStatus.all': 'Усі',
  'clinq.decision.pending': 'Немає рішення',
  'clinq.decision.cremation_individual': 'Індивідуальна кремація',
  'clinq.decision.cremation_general': 'Загальна кремація',
  'clinq.decision.burial': 'Поховання',
  'clinq.decision.pickup': 'Забирає власник',
  'clinq.decision.autopsy': 'Розтин',
  'clinq.branch.kharkiv': 'Харків',
  'clinq.branch.kyiv': 'Київ',
}

export const clinqEn: { [K in keyof typeof clinqUk]?: string } = {
  'nav.clinq': 'Clinical quality',
  'perm.clinq.read': 'Clinical quality: findings on own visit cards',
  'perm.clinq.read_all': 'Clinical quality: every doctor’s findings, antimicrobial report and prescription register',
  'perm.clinq.calls': 'Clinical quality: control calls (outcome, complications)',
  'perm.clinq.work': 'Clinical quality: euthanasia assessment and body tracker',
  'perm.clinq.manage': 'Clinical quality: card and call rules, substance list, report submission',
  'today.myFindings': 'Findings on my cards',
  'today.noFindings': 'No findings — cards are in order',
  'clinq.title': 'Clinical quality',
  'clinq.subtitle': 'Enote medical-card checks, control calls after treatment, the quarterly antimicrobial report and prescription register, euthanasia assessment and body tracker.',
  'clinq.noAccess': 'No access to this section',
  'clinq.toConfirm': 'to confirm',
  'clinq.toConfirmHint': 'Proposed from the clinic documents; waits for the chief doctor',
  'clinq.changePet': 'Change',
  'clinq.petSearch': 'Pet, owner or chip',
  'clinq.petNotFound': 'Nobody found in Enote',
  'clinq.lastVisit': 'visit',
  'clinq.ov.openTotal': 'open findings',
  'clinq.ov.myOpen': 'my findings',
  'clinq.ov.callsDue': 'calls due today',
  'clinq.ov.bodies': 'bodies in keeping',
  'clinq.ov.bodiesOverdue': 'bodies past the limit',
  'clinq.ov.reportDue': 'report {q} — due by',
  'clinq.ov.reportDone': 'report {q} submitted',
  'clinq.tab.cards': 'Cards',
  'clinq.tab.calls': 'Control calls',
  'clinq.tab.antimicrobial': 'Antimicrobials',
  'clinq.tab.euthanasia': 'Euthanasia & bodies',
  'clinq.statusFilter': 'Status',
  'clinq.ruleFilter': 'Rule',
  'clinq.anyRule': 'All rules',
  'clinq.onlyMine': 'My visits only',
  'clinq.rules': 'Rules',
  'clinq.lintRun': 'Check now',
  'clinq.lintDone': 'Visits checked: {n}; new findings: {open}; fixed: {fixed}',
  'clinq.noFindings': 'No open findings',
  'clinq.noFindingsHint': 'Bridge checks closed Enote visits daily against the rules (diagnosis, weight and temperature, doses, consents, labs, recommendations).',
  'clinq.notLinked': 'Your account is not linked to an Enote doctor — ask an admin to set it in Users.',
  'clinq.colRule': 'Rule',
  'clinq.colVisit': 'Visit',
  'clinq.colPatient': 'Patient',
  'clinq.colDoctor': 'Doctor',
  'clinq.colDetail': 'What is wrong',
  'clinq.colStatus': 'Status',
  'clinq.visit': 'Visit',
  'clinq.enoteId': 'Enote ID',
  'clinq.autoFixed': 'fixed in Enote',
  'clinq.moreRows': '{n} more — narrow the filter',
  'clinq.markedFixed': 'Marked fixed — the next check confirms it',
  'clinq.fixed': 'Fixed',
  'clinq.accept': 'Accept exception',
  'clinq.reopen': 'Reopen',
  'clinq.acceptTitle': 'Accept as a justified exception',
  'clinq.reopenTitle': 'Reopen the finding',
  'clinq.note': 'Note',
  'clinq.acceptHint': 'Why this is not a violation (required).',
  'clinq.byDoctor': 'By doctor (30 days)',
  'clinq.colOpen': 'Open',
  'clinq.colCritical': 'Critical',
  'clinq.colFixed': 'Fixed',
  'clinq.colAccepted': 'Exceptions',
  'clinq.colVisits': 'Visits',
  'clinq.noDoctor': 'No doctor',
  'clinq.rulesTitle': 'Card check rules',
  'clinq.rulesHint': 'Thresholds and word lists are configurable; «to confirm» ones wait for the chief doctor.',
  'clinq.openCount': 'open: {n}',
  'clinq.enabled': 'Enabled',
  'clinq.confirmed': 'Confirmed',
  'clinq.severityLabel': 'Severity',
  'clinq.severity.critical': 'Critical',
  'clinq.severity.warning': 'Warning',
  'clinq.severity.info': 'Info',
  'clinq.finding.open': 'Open',
  'clinq.finding.fixed': 'Fixed',
  'clinq.finding.accepted': 'Exception',
  'clinq.param.keywords': 'Words in visit type / services (visits the rule applies to)',
  'clinq.param.skip_keywords': 'Skip visits with words',
  'clinq.param.weight_keywords': 'Anamnesis questions with weight',
  'clinq.param.temperature_keywords': 'Anamnesis questions with temperature',
  'clinq.param.stage_text': '«Under examination» texts (do not justify an antimicrobial)',
  'clinq.param.template_keys': 'Surgery consent templates (keys)',
  'clinq.param.record_keywords': 'Anaesthesia record words',
  'clinq.param.checklist_keys': 'Process checklists counted as the record',
  'clinq.param.require_weight': 'Require weight',
  'clinq.param.require_temperature': 'Require temperature',
  'clinq.param.require_dose': 'Require dose',
  'clinq.param.require_course': 'Require course duration',
  'clinq.param.accept_enote_text': 'Recommendation text in Enote counts',
  'clinq.param.hours': 'Hours',
  'clinq.param.days': 'Days',
  'clinq.param.days_before': 'Consent signed at most this many days before',
  'clinq.callSearch': 'Client or pet',
  'clinq.callsCounters': 'Today: {today} · overdue: {overdue}',
  'clinq.callRules': 'Call rules',
  'clinq.callsCreated': 'Calls created: {n}',
  'clinq.callsGenerate': 'Create calls',
  'clinq.noCallsDue': 'No control calls due today',
  'clinq.noCallsHint': 'Calls are created N days after surgery, ВРІТ discharge or the first visit — by the rules the quality manager enables (Call rules).',
  'clinq.colDue': 'Date',
  'clinq.colReason': 'Reason',
  'clinq.colPhone': 'Phone',
  'clinq.attempts': 'attempts: {n}',
  'clinq.record': 'Outcome',
  'clinq.cancelCall': 'Cancel call',
  'clinq.incidentRaised': 'Incident №{n} raised for the doctors',
  'clinq.recordTitle': 'Control call: {pet}',
  'clinq.script': 'What to ask',
  'clinq.result': 'Outcome',
  'clinq.complicationHint': 'An incident «Complication after treatment» is raised — the doctor is notified.',
  'clinq.noAnswerHint': 'The call is repeated tomorrow; after several attempts it closes as «not reached».',
  'clinq.callNote': 'What the client said',
  'clinq.inquiryRef': 'Call-centre inquiry',
  'clinq.inquiryHint': 'Inquiry number if the call was logged as one (optional).',
  'clinq.reason': 'Reason',
  'clinq.callRulesTitle': 'Control call rules',
  'clinq.callRulesHint': 'Day N is not given in the clinic documents — values are proposed. Enable a rule once the chief doctor confirms the day.',
  'clinq.daysAfter': 'After days',
  'clinq.keywords': 'Words',
  'clinq.keywordsHint': 'Comma-separated; matched in drug names, case-insensitive.',
  'clinq.callStatus.due': 'Due today',
  'clinq.callStatus.planned': 'Planned',
  'clinq.callStatus.done': 'Done',
  'clinq.callStatus.cancelled': 'Cancelled',
  'clinq.result.ok': 'All fine',
  'clinq.result.complication': 'Complication',
  'clinq.result.revisit': 'Invited back',
  'clinq.result.no_answer': 'No answer',
  'clinq.trigger.visit_keywords': 'visit with words',
  'clinq.trigger.vrit_discharge': 'ВРІТ discharge',
  'clinq.trigger.first_visit': 'first visit',
  'clinq.anti.dimension': 'Breakdown',
  'clinq.anti.name': 'Name',
  'clinq.anti.group': 'Class',
  'clinq.anti.prescriptions': 'Prescriptions',
  'clinq.anti.lines': 'Lines',
  'clinq.anti.patients': 'Patients',
  'clinq.anti.year': 'Year',
  'clinq.anti.quarter': 'Quarter',
  'clinq.anti.q': 'Q{q}',
  'clinq.anti.reportFor': 'Antimicrobial report Q{q} {y}',
  'clinq.anti.dueOn': 'due by {date}',
  'clinq.anti.submitted': 'Submitted {date} · {who}',
  'clinq.anti.overdue': 'Past the due date',
  'clinq.anti.notSubmitted': 'Not submitted yet',
  'clinq.anti.undoSubmit': 'Remove the mark',
  'clinq.anti.markSubmitted': 'Mark submitted',
  'clinq.anti.empty': 'No antimicrobial prescriptions in the quarter',
  'clinq.anti.emptyHint': 'Enote prescriptions are matched to the substance list ({n} active) by words in drug names.',
  'clinq.anti.bySubstance': 'By substance',
  'clinq.anti.byGroup': 'By class',
  'clinq.anti.bySpecies': 'By species',
  'clinq.anti.byDoctor': 'By doctor',
  'clinq.print': 'Print',
  'clinq.register': 'Prescription register',
  'clinq.antiOnly': 'Antimicrobials only',
  'clinq.registerSearch': 'Drug, pet or owner',
  'clinq.registerHint': 'Required register fields (2026 law, 11 fields — list to confirm); empty ones are red — fill them in the Enote prescription.',
  'clinq.registerEmpty': 'No prescriptions in the period',
  'clinq.missing': 'missing',
  'clinq.field.number': 'Number',
  'clinq.field.issued_at': 'Date',
  'clinq.field.doctor': 'Doctor',
  'clinq.field.owner': 'Owner',
  'clinq.field.patient': 'Pet',
  'clinq.field.species': 'Species',
  'clinq.field.drug': 'Drug',
  'clinq.field.substance': 'Substance',
  'clinq.field.dose': 'Dose',
  'clinq.field.frequency': 'Frequency',
  'clinq.field.duration': 'Duration',
  'clinq.field.route': 'Route',
  'clinq.field.diagnosis': 'Diagnosis',
  'clinq.field.visit_number': 'Visit',
  'clinq.substances': 'Antimicrobial substances',
  'clinq.substanceAdd': 'Add substance',
  'clinq.substancesHint': 'Proposed list (to confirm): a drug counts for the first substance whose word is in its name.',
  'clinq.substanceKey': 'Key',
  'clinq.substanceKeyHint': 'a-z, 0-9, _',
  'clinq.active': 'Active',
  'clinq.euth.title': 'Assessment before euthanasia',
  'clinq.euth.new': 'New assessment',
  'clinq.euth.hint': 'HHHHHMM quality-of-life scale (7 criteria, 0–10), a second doctor for relative indications, the signed euthanasia consent (Consents). Once performed the body enters the tracker.',
  'clinq.euth.empty': 'No assessments yet',
  'clinq.euth.emptyHint': 'Create an assessment for a patient: fill the scale, set the indication and get the consent signed.',
  'clinq.euth.indication': 'Indication',
  'clinq.euth.score': 'Score / threshold',
  'clinq.euth.consent': 'Consent',
  'clinq.euth.titleFor': 'Assessment: {pet}',
  'clinq.euth.newHint': 'Find the patient in Enote and fill the scale.',
  'clinq.euth.indicationHint': 'Relative indications need a second doctor.',
  'clinq.euth.reason': 'Indications / diagnosis',
  'clinq.euth.scale': 'HHHHHMM quality-of-life scale',
  'clinq.euth.total': 'Total {total} of {max} · threshold {threshold}',
  'clinq.euth.openConsents': 'Generate the consent',
  'clinq.euth.second': 'Second doctor',
  'clinq.euth.secondMissing': 'not confirmed yet',
  'clinq.euth.confirmSecond': 'Confirm as second doctor',
  'clinq.euth.approve': 'Approve',
  'clinq.euth.performed': 'Performed',
  'clinq.euth.cancel': 'Cancel assessment',
  'clinq.indication.absolute': 'Absolute (medical)',
  'clinq.indication.relative': 'Relative',
  'clinq.consent.signed': 'Signed',
  'clinq.consent.sent': 'Sent',
  'clinq.consent.draft': 'Draft',
  'clinq.consent.declined': 'Declined',
  'clinq.consent.missing': 'Missing',
  'clinq.euthStatus.draft': 'Draft',
  'clinq.euthStatus.approved': 'Approved',
  'clinq.euthStatus.performed': 'Performed',
  'clinq.euthStatus.cancelled': 'Cancelled',
  'clinq.body.title': 'Body tracker',
  'clinq.body.new': 'Register a body',
  'clinq.body.hint': 'Where the body is kept, the owner’s decision and the limit: without a decision the body goes to the crematorium after 14 days (norm). Admins are reminded.',
  'clinq.body.empty': 'No bodies in keeping',
  'clinq.body.died': 'Death',
  'clinq.body.location': 'Storage location',
  'clinq.body.decision': 'Owner’s decision',
  'clinq.body.keepUntil': 'Keep until',
  'clinq.body.releasedTo': 'Released to {to}, {date}',
  'clinq.body.overdue': 'limit passed',
  'clinq.body.daysLeft': 'days left: {n}',
  'clinq.body.release': 'Release',
  'clinq.body.newHint': 'Death in ВРІТ or at home: find the patient, set the storage location and the owner’s decision.',
  'clinq.body.branch': 'Branch',
  'clinq.body.releaseTitle': 'Release body: {pet}',
  'clinq.body.releasedToLabel': 'Released to',
  'clinq.body.releasedToHint': 'Owner, crematorium or the person who took it.',
  'clinq.bodyStatus.stored': 'In keeping',
  'clinq.bodyStatus.released': 'Released',
  'clinq.bodyStatus.all': 'All',
  'clinq.decision.pending': 'No decision',
  'clinq.decision.cremation_individual': 'Individual cremation',
  'clinq.decision.cremation_general': 'General cremation',
  'clinq.decision.burial': 'Burial',
  'clinq.decision.pickup': 'Owner takes it',
  'clinq.decision.autopsy': 'Autopsy',
  'clinq.branch.kharkiv': 'Kharkiv',
  'clinq.branch.kyiv': 'Kyiv',
}
